<template>
    <layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Dashboard">
        <template #header>
            Dashboard
        </template>
        <div class="sm:p-6">
            <div class="py-4">
                <tw-table :headers="headers" :items="meetings.data">
                    <pagination class="mt-6" :data="meetings" />
                </tw-table>
            </div>
        </div>

        <tw-modal :show="showEditModal" @close="showEditModal = false" title="Edit Meeting">
            <jet-form-section  @submitted="updateMeeting">
                <template #form>
                    <div class="flex gap-4">
                        <div class="mt-1 relative rounded-md shadow-sm mb-4 w-1/2">
                            <jet-label for="jackpot" value="Jackpot Value" />
                            <jet-input :ignore-dark-mode="true" name="jackpot" v-model="getJackpot"  placeholder="50" class="mt-1 block w-full p-2" />
                            <div v-show="updateForm.errors.jackpot" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                            <jet-input-error :message="updateForm.errors.jackpot" class="mt-2" />
                        </div>

                        <div class="mt-1 relative rounded-md shadow-sm mb-4 w-1/2">
                            <jet-label for="price" value="Price to play" />
                            <jet-input :ignore-dark-mode="true" name="price" v-model="getPrice"  placeholder="10" class="mt-1 block w-full p-2"/>
                            <div v-show="updateForm.errors.price" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                            <jet-input-error :message="updateForm.errors.price" class="mt-2" />
                        </div>
                    </div>
                    <div class="flex gap-4">

                        <div class="mt-1 relative rounded-md shadow-sm mb-4 w-1/2">
                            <jet-label for="minimum" value="Minimum for increase" />
                            <jet-input :ignore-dark-mode="true" name="minimum" type="number" step=".1" v-model="getMinimum"  placeholder="50" class="mt-1 block w-full p-2" />
                            <div v-show="updateForm.errors.minimum" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                            <jet-input-error :message="updateForm.errors.extra_tokens" class="mt-2" />
                        </div>
                        <div class="mt-1 relative rounded-md shadow-sm mb-4 w-1/2">
                            <jet-label for="extra_tokens" value="Increaser" />
                            <jet-input :ignore-dark-mode="true" name="extra_tokens" type="number" step=".1" v-model="getExtratokens"  placeholder="50" class="mt-1 block w-full p-2" />
                            <div v-show="updateForm.errors.extra_tokens" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                            <jet-input-error :message="updateForm.errors.extra_tokens" class="mt-2" />
                        </div>

                    </div>
                    <div class="flex gap-4">
                        <div  class="mt-1 relative rounded-md shadow-sm mb-4 w-1/2">
                            <jet-label for="named_prize" value="Named Prize" />
                            <jet-input :ignore-dark-mode="true" name="named_prize" v-model="getNamed" class="mt-1 block w-full p-2" />
                            <div v-show="updateForm.errors.getNamed" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                            <jet-input-error :message="updateForm.errors.jackpot" class="mt-2" />
                        </div>

                        <div v-show="updateForm.errors.price" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>
                    </div>

                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
                        <jet-label for="price" value="Currency payout" />
                        <div class="flex gap-4 mt-2">
                            <div>
                                <input type="radio" id="cash" name="currency" value="cash" v-model="getCurrency" />
                                <label for="cash">Cash</label>
                            </div>
                            <div>
                                <input type="radio" id="token" name="currency" value="token" v-model="getCurrency" />
                                <label for="token">Tokens</label>
                            </div>
                            <div>
                                <input type="radio" id="named" name="currency" value="named" v-model="getCurrency" />
                                <label for="named">Named</label>
                            </div>

                        </div>

                        <jet-input-error :message="updateForm.errors.price" class="mt-2" />
                    </div>
                    <div class="mt-1 relative rounded-md shadow-sm mb-4">
                        <div class="col-span-6">
                            <div class="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                                <label class="flex items-center">
                                    <jet-checkbox :checked="!!selectedMeeting.featured"  v-model="updateForm.featured" :value="value" name="featured"/>
                                    <span class="ml-2 text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white">Featured</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-span-6">
                            <div class="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                                <label class="flex items-center">
                                    <jet-checkbox :checked="!!selectedMeeting.split"   v-model="updateForm.split" :value="value" name="split"/>
                                    <span class="ml-2 text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white">Split Jackpot</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-span-6">
                            <div class="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                                <label class="flex items-center">
                                    <jet-checkbox :checked="!!selectedMeeting.hidden"   v-model="updateForm.hidden" :value="value" name="hidden"/>
                                    <span class="ml-2 text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white">Hidden</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </template>

                <template #actions>
                    <jet-button class="text-right" :ignore-dark-mode="true" :class="{ 'opacity-25': updateForm.processing }" :disabled="updateForm.processing">
                        Save
                    </jet-button>
                </template>
            </jet-form-section>
        </tw-modal>
    </layout>
</template>
<script>
import Layout from '@/Layouts/Layout'
import TwCard from '@/Global/Elements/TwCard'
import moment from 'moment'
import JetInput from '@/Jetstream/Input.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetSelect from '@/Jetstream/Select.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import {ExclamationCircleIcon} from "@heroicons/vue/solid";
import TwTable from '@/Global/Elements/TwTable'
import TwModal from '@/Global/Elements/TwModal'
import Pagination from '@/Global/Pagination'
import {DatabaseIcon, UserIcon, UserRemoveIcon, XCircleIcon} from "@heroicons/vue/outline";
import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";


export default {
    emits: ['update:checked'],
    props: {
        meetings: {
            type: Object,
        },
        checked: {
            type: [Array, Boolean],
            default: false,
        },
        value: {
            default: null,
        },

    },
    components: {
        Layout,
        TwCard,
        JetInput,
        JetCheckbox,
        JetInputError,
        JetButton,
        JetLabel,
        JetFormSection,
        ExclamationCircleIcon,
        TwTable,
        Pagination,
        TwModal,
        JetSelect
    },

    setup(props){
        const options = ref([{
            name: 'Cash',
            value: 'cash',
        },
        {
            name: 'Tokens',
            value: 'token',
        },
        {
            name: 'Named',
            value: 'named',
        }
        ])

        const showEditModal = ref(false)

        const selectedMeeting = ref(null)

        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const toTitleCase = (str) => {
            return str.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())
        }

        const updateForm = Inertia.form({
            meeting_id: null,
            jackpot: null,
            price: null,
            featured: null,
            currency: null,
            hidden: null,
            extra_tokens: null,
            minimum: null,
            split: null,
            named_prize: null,
        })
        const updateMeeting = () => {
            updateForm
                .transform((data) => ({
                    ...data,
                    action: 'updateMeeting',
                    meeting_id: selectedMeeting.value.id,
                }))
                .post(route('admin.races.update'), {
                    onSuccess: (success) => {
                        showEditModal.value = false
                        updateForm.reset()
                    },
                    onError: (error) => {
                        console.log(error)
                    }
                })
        }
        const headers = [
            { text: 'ID', value: 'id' },
            { text: 'Name', value: 'name' },
            { text: 'Currency', value: 'currency' },
            { text: 'Prize', value: 'amount' },
            { text: 'Increment', value: 'extra_tokens' },
            { text: 'Minimum', value: 'minimum' },
            { text: 'Entry Fee', value: 'price' },
            { text: 'Featured', value: 'featured' },
            { text: 'Hidden', value: 'hidden' },
            { text: 'Split Jackpot', value: 'split' },
            { text: '', value: [
                    {
                        name: 'Edit',
                        icon: DatabaseIcon,
                        action: 'updateMeeting',
                        disabled: false,
                        showText: true,
                        class: '',
                        method: (item) => {
                            selectedMeeting.value = item
                            showEditModal.value = true
                        }
                    },
                ]},
        ]
        return {
            toTitleCase,
            moment,
            headers,
            showEditModal,
            updateForm,
            updateMeeting,
            selectedMeeting,
            options
        }
    },
    computed: {
        featuredCheck: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
        splitCheck: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
        hiddenCheck: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
        getCurrency: {
            get() {
                return this.selectedMeeting.currency;
            },
            set(val) {
                this.updateForm.currency = val;
            },
        },
        getPrice: {
            get() {
                return this.selectedMeeting.price;
            },
            set(val) {
                this.updateForm.price = val;
            },
        },
        getMinimum: {
            get() {
                return this.selectedMeeting.minimum / 100;
            },
            set(val) {
                this.updateForm.minimum = val;
            },
        },
        getJackpot: {
            get() {
                return this.selectedMeeting.amount / 100;
            },
            set(val) {
                this.updateForm.jackpot = val;
            },
        },
        getExtratokens: {
            get() {
                return this.selectedMeeting.extra_tokens / 100;
            },
            set(val) {
                this.updateForm.extra_tokens = val;
            },
        },
        getNamed: {
            get() {
                return this.selectedMeeting.named_prize;
            },
            set(val) {
                this.updateForm.named_prize = val;
            },
        },
    },

}
</script>
